import {z} from 'zod';
import {GenericTaskSchema, TaskType} from '../../task';
import {ApiDefinition} from '../definitions';
import {ObjectIdSchema} from '../../zod';

const GetTaskResponseSchema = GenericTaskSchema.pick({
  state: true,
  detailedState: true,
})
  .extend({
    id: ObjectIdSchema,
  })
  .nullable();
export type GetTaskResponse = z.infer<typeof GetTaskResponseSchema>;

const GetTaskRequestSchema = z.union([
  z.object({
    type: z.enum([
      'fileCRMImport',
      'generateAnalystAgent',
      'generateCampaigns',
      'generateSegmentationAgent',
      'generateTeamSizeAgent',
      'generateSegments',
      'hubSpotFullRun',
      'importLinkedInAdAccounts',
      'salesforceFullRun',
    ] as const satisfies TaskType[]),
  }),
  z.object({
    type: z.literal('accountEnrichment' satisfies TaskType),
    fieldDefinitionId: ObjectIdSchema,
  }),
  z.object({
    type: z.literal('generateMarketReport' satisfies TaskType),
    marketId: ObjectIdSchema,
  }),
]);

export type GetTaskRequest = z.infer<typeof GetTaskRequestSchema>;

export const GetTask = {
  path: 'task',
  method: 'get',
  options: {access: 'paid'},
  requestDataSchema: GetTaskRequestSchema,
  responseDataSchema: GetTaskResponseSchema,
} satisfies ApiDefinition;
